module.exports = __webpack_public_path__ + "static/img/logo.d3907f8.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Login/logo.png
// module id = 489
// module chunks = 0